import React, { useState } from 'react';
import { IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

const drawerItemSx = {
  '& .MuiTypography-root': {
    color: '#24312B',
    fontFamily: "'Albert Sans', sans-serif",
    fontWeight: 500,
  },
  '&:hover': {
    backgroundColor: '#F1EBE1',
  },
};

function ResponsiveAppBar() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <header className="fe-header">
        <div className="fe-header-inner">
          <Link to="/" className="fe-wordmark">
            <span className="fe-wordmark-name">Fé Escrita</span>
            <span className="fe-wordmark-kicker">devocional diário</span>
          </Link>

          <nav className="fe-nav">
            <Link to="/">Reflexões</Link>
            <Link to="/about">Sobre</Link>
            <Link to="/privacy-policy">Privacidade</Link>
            <a href="/#app" className="fe-cta-pill">Baixar o app</a>
          </nav>

          <IconButton
            edge="end"
            aria-label="menu"
            onClick={handleDrawerOpen}
            sx={{ color: '#24312B', display: { xs: 'inline-flex', md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        </div>
      </header>

      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={handleDrawerClose}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#F8F5EF',
            color: '#24312B',
            minWidth: '240px',
          },
        }}
      >
        <List>
          <ListItem button component={Link} to="/" onClick={handleDrawerClose} sx={drawerItemSx}>
            <ListItemText primary="Reflexões" />
          </ListItem>
          <ListItem button component={Link} to="/about" onClick={handleDrawerClose} sx={drawerItemSx}>
            <ListItemText primary="Sobre" />
          </ListItem>
          <ListItem button component={Link} to="/privacy-policy" onClick={handleDrawerClose} sx={drawerItemSx}>
            <ListItemText primary="Privacidade" />
          </ListItem>
          <ListItem
            button
            component="a"
            href="https://www.youtube.com/@CoracaoCristao-go7ms"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleDrawerClose}
            sx={drawerItemSx}
          >
            <ListItemText primary="Coração Cristão" />
          </ListItem>
          <ListItem
            button
            component="a"
            href="/#app"
            onClick={handleDrawerClose}
            sx={{
              ...drawerItemSx,
              backgroundColor: '#365E4B',
              margin: '8px 16px',
              borderRadius: '999px',
              width: 'auto',
              '& .MuiTypography-root': {
                color: '#FFFFFF',
                fontFamily: "'Albert Sans', sans-serif",
                fontWeight: 600,
                textAlign: 'center',
              },
              '&:hover': {
                backgroundColor: '#2A4A3B',
              },
            }}
          >
            <ListItemText primary="Baixar o app" />
          </ListItem>
        </List>
      </Drawer>
    </>
  );
}

export default ResponsiveAppBar;
